export default __webpack_public_path__ + "static/media/e1.c0e848e2.webp";